import { Phone } from "@phosphor-icons/react";

export default function EmergencyBanner() {
  return (
    <div
      data-testid="emergency-banner"
      className="w-full bg-[#C85A40] text-white text-sm py-2.5 px-6 flex items-center justify-center gap-3 relative z-50"
    >
      <span className="inline-block w-2 h-2 rounded-full bg-white soft-pulse" />
      <span className="font-medium hidden sm:inline">24/7 Emergency Care —</span>
      <a
        href="tel:+919462020447"
        data-testid="emergency-phone-link"
        className="inline-flex items-center gap-2 font-semibold hover:underline underline-offset-4"
      >
        <Phone size={16} weight="fill" />
        +91 9462 02 0447
      </a>
      <span className="hidden md:inline opacity-80">| Ambulance dispatch in under 8 min</span>
    </div>
  );
}
